import { BotFlow } from '@feedyou/schema'

import { ValidationResult } from '../types'
import {
  validateAndFixDuplicateIdsInBot,
  validateAndFixDuplicateIdsInNlpSettings
} from '../subfeatures/duplicateIdsValidation'

export const validateAndCorrectBotJson = async (params: {
  flow: BotFlow
  isIdValidationEnabled: boolean
}): Promise<ValidationResult<BotFlow>> => {
  const { nlp = {}, ...bot } = params.flow
  const isIdValidationDisabled = !params.isIdValidationEnabled

  const resultForBot = await validateAndFixDuplicateIdsInBot(bot, isIdValidationDisabled)
  if (!resultForBot.didValidateSuccessfully) {
    return resultForBot
  }

  const resultForNlp = await validateAndFixDuplicateIdsInNlpSettings(nlp, isIdValidationDisabled)
  if (!resultForNlp.didValidateSuccessfully) {
    return { ...resultForBot, correctedEntity: { ...resultForBot.correctedEntity, nlp } }
  }

  return {
    ...resultForBot,
    correctedEntity: { ...resultForBot.correctedEntity, nlp: resultForNlp.correctedEntity }
  }
}
